import { skipToken, useQuery } from '@tanstack/react-query';
import type { SystemEntity } from '@erp/shared-types';
import { orpc } from 'src/api/rpc/client';

/**
 * Selectable anchor-entity columns for a task-page column picker
 * (`tasks.anchorFieldCatalog`). Idle until the page's anchor entity type is
 * known; unsupported/unreadable types return `supported: false`.
 */
export function useTaskAnchorFieldCatalog(
  entityType: SystemEntity | null | undefined,
) {
  return useQuery({
    ...orpc.tasks.anchorFieldCatalog.queryOptions({
      input: entityType ? { entityType } : skipToken,
    }),
    staleTime: 10 * 60 * 1000,
  });
}
